import {
  CHART_STORE_FORCE_DATA,
  CHART_STORE_REMOVE,
  CHART_STORE_UPDATE,
} from '../../constants/ActionTypes';

function updateChartStore(state, id, chartData) {
  const updatedData = state.data;

  if (!updatedData[id]) {
    updatedData[id] = {};
  }

  updatedData[id] = {
    ...updatedData[id],
    ...chartData,
  };

  state.data = updatedData;

  return state;
}

function removeChartStore(state, id) {
  const updatedData = state.data;

  if (updatedData[id]) {
    delete updatedData[id];
  }

  state.data = updatedData;

  return state;
}

const chartStore = (
  state = {
    data: {},
  },
  action
) => {
  switch (action.type) {
    case CHART_STORE_UPDATE:
      return {
        ...state,
        data: updateChartStore(state, action.id, action.data).data,
      };
    case CHART_STORE_FORCE_DATA:
      return {
        ...state,
        data: action.data,
      };
    case CHART_STORE_REMOVE:
      return {
        ...state,
        data: removeChartStore(state, action.id).data,
      };
    default:
      return state;
  }
};

export default chartStore;
